import { ApiConfig } from "../apiConfig/apiConfig";
import { ApiCallGet, ApiCallPost } from "../apiConfig/apiCall";

function bearerHeaders() {
  const raw = localStorage.getItem("token");
  if (!raw) return { "Content-Type": "application/json" };
  const token = !String(raw).startsWith("Bearer ") ? `Bearer ${raw}` : raw;
  return { "Content-Type": "application/json", Authorization: token };
}

/** Bearer header without Content-Type so axios can set the multipart boundary. */
function bearerAuthHeader() {
  const raw = localStorage.getItem("token");
  if (!raw) return {};
  const token = !String(raw).startsWith("Bearer ") ? `Bearer ${raw}` : raw;
  return { Authorization: token };
}

const KybService = {
  /** Current KYB (canonical SessionPayload) — `GET /api/v1/kyb/status`. */
  getStatus: async () => {
    const { baseKybApi, kybStatus } = ApiConfig;
    const url = baseKybApi + kybStatus;
    return ApiCallGet(url, bearerHeaders());
  },

  /** Start or resume a Didit KYB session — `POST /api/v1/kyb/session`. */
  createSession: async (body = {}) => {
    const { baseKybApi, kybSession } = ApiConfig;
    const url = baseKybApi + kybSession;
    return ApiCallPost(url, body, bearerHeaders());
  },

  /**
   * Submit a corporate KYB application.
   * `payload` shape:
   *   {
   *     authorizedSignatoryFullName, corporateEmail,
   *     registeredCompanyName, countryOfIncorporation,
   *     files: { tradeLicense, certificateOfIncorporation, memorandumArticles,
   *              shareholderRegister, uboDeclaration, authorizedSignatoryId,
   *              uboIds, signedBoardResolution }
   *   }
   */
  submitKyb: async (payload = {}) => {
    const { baseAuth, submitKyb } = ApiConfig;
    const url = baseAuth + submitKyb;

    const formData = new FormData();
    formData.append("authorizedSignatoryFullName", payload.authorizedSignatoryFullName ?? "");
    formData.append("corporateEmail", payload.corporateEmail ?? "");
    formData.append("registeredCompanyName", payload.registeredCompanyName ?? "");
    formData.append("countryOfIncorporation", payload.countryOfIncorporation ?? "");
    formData.append("confirmation", "true");

    const files = payload.files || {};
    Object.keys(files).forEach((field) => {
      if (files[field]) formData.append(field, files[field]);
    });

    return ApiCallPost(url, formData, bearerAuthHeader());
  },
};

export default KybService;
